import { AccessStatusIdEnum } from 'utils/enums';

export const checkTrialFinished = (pointOfSale: any) => {
    return pointOfSale.access_status_id === AccessStatusIdEnum.Enabled && pointOfSale.status_id === 3;
};
